import { Alert, Box, CircularProgress, Divider, IconButton, Link, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ASSETS_BASE_URL } from "../../config";
import { useNavigate } from "react-router-dom";
import Datagrid from "../Datagrid/Datagrid";
import customHttp from "../../services/customHTTP";
import { useSite } from "../../context/siteContext";
import SummarizeIcon from "@mui/icons-material/Summarize";
import RequestHistoryDetails from "../RequestHistoryDetails/RequestHistoryDetails";

const RequestsHistory = () => {
	const [requestHistory, setRequestHistory] = useState([]);
	const [selectedRLHistoryRows, setSelectedRLHistoryRows] = useState([]);
	const [loading, setLoading] = useState(false);
	const [viewDetails, setViewDetails] = useState(false);
	const [selectedRequest, setSelectedRequest] = useState({});
	const [error, setError] = useState("");
	const { selectedSite } = useSite();
	const navigate = useNavigate();

	useEffect(() => {
		if (selectedSite) {
			fetchHistory();
		}
	}, [selectedSite]);

	const handleRowSelect = (rows) => {
		setSelectedRLHistoryRows(rows);
	};

	const formatDate = (dateString) => {
		const date = new Date(dateString);
		const month = `0${date.getMonth() + 1}`.slice(-2); // Get month (01-12)
		const day = `0${date.getDate()}`.slice(-2); // Get day (01-31)
		const year = date.getFullYear(); // Get full year
		const hours = `0${date.getHours()}`.slice(-2); // Get hours (00-23)
		const minutes = `0${date.getMinutes()}`.slice(-2); // Get minutes (00-59)

		return `${year}-${month}-${day} ${hours}:${minutes}`; // Return formatted date
	};

	const fetchHistory = async () => {
		setLoading(true);
		const req_body = {
			selectedSite,
		};
		try {
			const response = await customHttp.post("/request_list/history", req_body);
			if (response.data.success) {
				setRequestHistory(response.data.history);
				setLoading(false);
			}
		} catch (error) {
			console.log(error);
			setError(error);
		}
	};

	const handleViewDetails = (row) => {
		console.log(row);
		setSelectedRequest(row);
		setViewDetails(true);
	};

	const handleViewDetailsRowClick = (row) => {
		console.log(row);
		setSelectedRequest(row.row);
		setViewDetails(true);
	};

	const columns = [
		{
			field: "request_number",
			headerName: "Request #",
			flex: 1,
			renderCell: (params) => (
				<Tooltip title="View Request Details">
					<span
						style={{
							cursor: "pointer",
							fontWeight: "bold",
						}}
						onMouseEnter={(e) => (e.target.style.fontWeight = "bold")}
						onMouseLeave={(e) => (e.target.style.fontWeight = "bold")}>
						{params.value}
					</span>
				</Tooltip>
			),
		},
		{ field: "parts_count", headerName: "Requested Parts", width: 100, align: "center", headerAlign: "center" },
		{ field: "user_name", headerName: "Requested By", width: 200, align: "center", headerAlign: "center" },
		{
			field: "created",
			headerName: "Created Date",
			valueFormatter: (value) => formatDate(value),
			width: 250,
			align: "center",
			headerAlign: "center",
		},
		{
			headerName: "View Details",
			width: 100,
			sortable: false,
			headerAlign: "center",
			align: "center",
			renderCell: (params) => (
				<div>
					<Tooltip title="View Details">
						<IconButton
							color="primary"
							aria-label="View Details"
							onClick={(event) => {
								event.stopPropagation();
								handleViewDetails(params.row);
							}}>
							<SummarizeIcon />
						</IconButton>
					</Tooltip>
				</div>
			),
		},
	];

	if (loading) {
		return (
			<Box
				sx={{
					width: "100%",
					height: "400px",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}>
				<CircularProgress />
			</Box>
		);
	}

	if (error && error !== "" && !loading) {
		return (
			<Alert severity="error" className="error-alert" sx={{ marginTop: "10px" }}>
				Error Fetching History
			</Alert>
		);
	}

	if ((!requestHistory || requestHistory.length <= 0) && !loading && error !== "") {
		return (
			<Alert severity="info" className="error-alert" sx={{ marginTop: "10px" }}>
				No History Available
			</Alert>
		);
	}

	return (
		<>
			<Datagrid
				key="request_number"
				data={requestHistory}
				columns={columns}
				pageSize={5}
				showSearchBar={true}
				checkboxSelection={false}
				rowClick={true}
				onRowClick={handleViewDetailsRowClick}
				// onSelect={handleRowSelect}
				rowIdField="request_number"
				sortBy={[{ field: "request_created_date", sort: "desc" }]}
			/>
			{viewDetails && (
				<RequestHistoryDetails
					selectedRow={selectedRequest}
					viewDetails={viewDetails}
					setViewDetails={setViewDetails}
				/>
			)}
		</>
	);
};

export default RequestsHistory;
